import { render, staticRenderFns } from "./MultiSelectBox.vue?vue&type=template&id=5235df34"
import script from "./MultiSelectBox.vue?vue&type=script&lang=ts"
export * from "./MultiSelectBox.vue?vue&type=script&lang=ts"
import style0 from "./MultiSelectBox.vue?vue&type=style&index=0&id=5235df34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports